import { IOneGallery } from './Common';
//根据gallery-list.scss的设定，大于450认为是PC级别的，需要将高度*2
const isPcSize = document.documentElement.clientWidth >= 450;

const DEFAULT_WATERFALL_HEIGHT = Math.floor(350 * 0.6666);

const radioHeight = (width: number, height: number) => {
  let percent = width / 350;
  return Math.floor(height / percent);
};

const getSafeWaterfallHeight = (width?: number, height?: number) => {
  const realWidth = Number(width);
  const realHeight = Number(height);

  if (
    Number.isFinite(realWidth) &&
    realWidth > 0 &&
    Number.isFinite(realHeight) &&
    realHeight > 0
  ) {
    const result = radioHeight(realWidth, realHeight);
    if (Number.isFinite(result) && result > 0) {
      return result;
    }
  }

  return DEFAULT_WATERFALL_HEIGHT;
};

export default function(list: IOneGallery[]) {
  let column1 = [] as IOneGallery[];
  let column2 = [] as IOneGallery[];

  let column1height = 0;
  let column2height = 0;

  list.forEach((it: IOneGallery, index: number) => {
    // one.originalIndex = index;
    const one = {
      ...it,
      originalIndex: index
    };
    
    if (column1height <= column2height) {
      column1.push(one);
      column1height += getSafeWaterfallHeight(one.width, one.height);
    } else {
      column2.push(one);
      column2height += getSafeWaterfallHeight(one.width, one.height);
    }
  });

  return {
    column1,
    column2
  };
}
